import { LoadingOverlayComponent } from './loading-overlay/loading-overlay.component';
import { PplLoadingComponent } from './loading.component';
import { PplIconModule } from '../icon';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [
    CommonModule,
    PplIconModule
  ],
  declarations: [
    PplLoadingComponent,
    LoadingOverlayComponent
  ],
  exports: [
    PplLoadingComponent,
    LoadingOverlayComponent
  ]
})
export class PplLoadingModule {
}

export * from './loading.component';
